// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"vy_a bhc_b bhc_wb"};